import { SvgIcon } from "@mui/material";

export default function MenuVertical(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="14"
        viewBox="0 0 4 14"
        fill="none"
      >
        <path
          d="M2.0001 2.8C2.7733 2.8 3.4001 2.1732 3.4001 1.4C3.4001 0.626801 2.7733 0 2.0001 0C1.2269 0 0.600098 0.626801 0.600098 1.4C0.600098 2.1732 1.2269 2.8 2.0001 2.8Z"
          fill="#8E97A7"
        />
        <path
          d="M2.0001 8.39998C2.7733 8.39998 3.4001 7.77317 3.4001 6.99998C3.4001 6.22678 2.7733 5.59998 2.0001 5.59998C1.2269 5.59998 0.600098 6.22678 0.600098 6.99998C0.600098 7.77317 1.2269 8.39998 2.0001 8.39998Z"
          fill="#8E97A7"
        />
        <path
          d="M2.0001 14C2.7733 14 3.4001 13.3732 3.4001 12.6C3.4001 11.8268 2.7733 11.2 2.0001 11.2C1.2269 11.2 0.600098 11.8268 0.600098 12.6C0.600098 13.3732 1.2269 14 2.0001 14Z"
          fill="#8E97A7"
        />
      </svg>
    </SvgIcon>
  );
}
